import { Check, Lock, PencilLine } from "lucide-react";
import { DocumentState } from "@/services/backend/documents/types/state";

/**
 * DocumentStateIcon identifies a [DocumentState]: a draft is still written
 * on, a ready document is complete, a written down document is locked.
 */
export function DocumentStateIcon({
  state,
  className = "h-4 w-4",
}: {
  state: DocumentState;
  className?: string;
}) {
  switch (state) {
    case DocumentState.Ready:
      return <Check className={className} />;
    case DocumentState.Immutable:
      return <Lock className={className} />;
    default:
      return <PencilLine className={className} />;
  }
}
